// Utility to get unique_id from URL query parameters
// This unique_id will be used in all API calls for the KYC flow

export const getUniqueId = () => {
  const urlParams = new URLSearchParams(window.location.search);
  return urlParams.get('unique_id');
};

export const validateUniqueId = () => {
  const uniqueId = getUniqueId();
  if (!uniqueId) {
    console.warn('No unique_id found in URL. KYC flow requires unique_id parameter.');
    return false;
  }
  return true;
};

